import React from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';
import validate from "validate.js";

import './signin_component.scss';
import { signInUser } from '../../../../gateway/api';
import LoginProviders from "../../login_providers";
import { signInConstraints } from '../../../../util/validation_constraints';
import { showCloseButtonClass, errorClass, clearInputContent } from '../../../../util/form_login_utils';
import ErrorMessageComponent from '../get_error_message';
import ApiErrorMessageComponent from '../get_api_error_message';
import ShowSignupButton from '../signup_button';

const SignInComponent = ({handleChange, onButtonClick, loginObj, forgotPassword, screen, errors, clearInput, apiErrors, closeLogin, userLogin, action}) => {
  return(
    <div className="signin-component">
      {inputField(loginObj, handleChange, errors, clearInput, apiErrors)}
      <ApiErrorMessageComponent />
      <div className="signin-component-action-container">
        {showLoginProviders(loginObj, screen, userLogin)}
        <div className={toggleActionButtonsContainer(loginObj, screen)}>
          <div className="buttons-container">
            {showButtonComponent({'name': 'Sign in'}, onButtonClick, loginObj, screen, errors, action, userLogin)}
          </div>
          <div className="signin-component__links">
            <ShowSignupButton />
            {showForgotPassword(forgotPassword, screen, loginObj)}
          </div>
        </div>
      </div>
    </div>
  )
}

const showForgotPassword = (forgotPassword, screen, loginObj) => {
  return(
    <div className="forgot-password"
         onClick={(e) => forgotPassword(e)}>
      Forgot Password ?
    </div>
  )
}

const inputField = (loginObj={}, handleChange, errors, clearInput, apiErrors) => {
  const signinFields = [{label: "email", name: "email"}, {label: "password", name: "password"}];
  return signinFields.map((signinField, index) => {
    return (
      <div key={index} className="input-field-container" id="input-field-container">
       <label htmlFor="textInput" className="input-label">{signinField.name}</label>
         <div className="field">
          <input type={signinField.label}
                 className={`input-field-box ${errorClass(errors, signinField.label)} ${signinField.label}`}
                 value={loginObj[signinField.label]}
                 name={signinField.name}
                 onChange={(e) => handleChange(e, loginObj, signinField.label, errors, apiErrors)}></input>
          <span className={`input-close-button ${showCloseButtonClass(loginObj[signinField.label])}`}
                onClick={(e) => clearInput(e, signinField.label, loginObj, errors)}></span>
        </div>
        <ErrorMessageComponent inputField={signinField.label}/>
      </div>
    )
  })
}

const showLoginProviders = (loginObj, screen, userLogin) => {
  return(
    <div className={toggleLoginProviders(loginObj, screen)}>
      <LoginProviders userLogin={userLogin}/>
    </div>
  )
}

const showButtonComponent = (opts, onButtonClick, loginObj, screen, errors, action, userLogin) => {
  return(
    <div className="metype-button-container">
      <button type="submit" className="metype-button" onClick={(e) => onButtonClick(e, loginObj, errors, action, userLogin)}>
        {opts.name}
      </button>
    </div>
  )
}

const toggleActionButtonsContainer = (loginObj, screen) => {
  const toggleActionButtonsContainerClass = classnames('toggle-action-buttons',
                                   {'toggle-action-buttons__visible': (screen === 'signin' && (loginObj.email.length > 0 || loginObj.password.length > 0))});
  return toggleActionButtonsContainerClass;
}

const toggleLoginProviders = (loginObj, screen) => {
  const toggleLoginProvidersContainerClass = classnames('toggle-login-providers',
                                   {'toggle-login-providers__visible': (screen === 'signin' && (loginObj.email.length === 0 && loginObj.password.length === 0))},
                                   {'toggle-login-providers__invisible': (screen === 'signin' && (loginObj.email.length > 0 || loginObj.password.length > 0))});
  return toggleLoginProvidersContainerClass;
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    loginObj: formLoginReducers.loginObj,
    screen: formLoginReducers.screen,
    errors: formLoginReducers.errors,
    apiErrors: formLoginReducers.apiErrors
  }
}

const handleSignInErrors = (errResponse, dispatch) => {
  const responseBody = errResponse.res.body.error;
  const errCode = errResponse.res.statusCode;

  if (responseBody === 'invalid password' && errCode === 401) {
    dispatch({type: 'API_ERRORS', message: "Invalid Credentials"});
  } else if (responseBody === 'Invalid email or password' && errCode === 404) {
    dispatch({type: 'API_ERRORS', message: "Invalid Credentials"});
  } else if (responseBody === 'user not authenticated' && errCode === 401) {
    dispatch({ type: 'SCREEN' , screen: 'confirmOtp', source: "signIn"});
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    clearInput: (e, signinFieldLabel, loginObj, errors) => {
      clearInputContent(e, signinFieldLabel, loginObj, errors, dispatch)
    },
    handleChange: (e, loginObj, signinField, errors, apiErrors) => {
      if(e.target.value.length === 0 && ((errors[e.target.name] && errors[e.target.name].length > 0))) {
        dispatch({ type: 'ERRORS', ...errors, [e.target.name]: ""});
      }
      if(e.target.value.length === 0 && Object.keys(apiErrors).length > 0) {
        dispatch({type: 'API_ERRORS', apiErrors: {}});
      }
      dispatch({type: 'LOGIN', ...loginObj, [e.target.name]: e.target.value});
    },
    onButtonClick: (e, loginObj, errors, action, userLogin) => {
      e.preventDefault();
      e.stopPropagation();

      dispatch({type: 'API_ERRORS', apiErrors: {}});

      const validateResponse = validate(loginObj, signInConstraints(), { fullMessages: false }) || {};
      dispatch({type: 'ERRORS', ...validateResponse});

      const ssoRedirect = (response) => {
        dispatch({type: "LOGIN_SETUSER", currentUser: response.current_user, signedIn: response.success})
        dispatch({type: 'ERRORS', ...validateResponse});
        if(response["sso_redirect_uri"]) {
          window.location.href =  response["sso_redirect_uri"]
        } else if(action && response.current_user) {
          userLogin();
          return;
        }
        else {
          window.location.href = "/admin"
        }
      }

      if(Object.keys(validateResponse).length === 0) {
        signInUser( { user: { email: loginObj.email, password: loginObj.password }, sso: true})
        .then((response) => {
          ssoRedirect(response);
        })
        .catch((err) => {
	         handleSignInErrors(err,dispatch)
        })
      }
    },
    forgotPassword: (e) => {
      dispatch({ type: 'SCREEN', screen: 'emailConfirmation'});
      dispatch({ type: 'ERRORS', errors: ''});
      dispatch({type: 'API_ERRORS', message: ""});
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(SignInComponent);



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/signin_component/signin_component.js